import SettingElement from '@/game/GameComponents/PhaserGame/UI/SettingElement';
import { PhaserAudioManager } from '@/game/GameComponents/PhaserGame/Utils/PhaserAudioManager';
import {
  setBitmapColor,
  shouldSubmitOnPointerUp,
} from '@/game/GameComponents/PhaserGame/Utils/PhaserUtils';
import { HOVER_CURSOR_PATH } from '@/game/GameComponents/Utils/GameSpriteAssetsMap';
import RadioButton from '@/game/prefabs/RadioButton/RadioButton';

export class RadioButtonController {
  constructor(public radioButton: RadioButton) {
    const { settingLabel, button, buttonLabel, interactionHitbox } =
      radioButton;
    settingLabel.setText(buttonLabel);

    button.setInteractive({ cursor: `${HOVER_CURSOR_PATH}, auto` });
    interactionHitbox.setInteractive({ cursor: `${HOVER_CURSOR_PATH}, auto` });

    this.settingElement = new SettingElement({
      key: radioButton.key,
      element: radioButton,
      settingLabel: settingLabel,
      tooltipBacking: radioButton.tooltipBacking,
      tooltipText: radioButton.tooltipText,
      helpIcon: radioButton.helpIcon,
      settingTooltip: radioButton.settingTooltip,
    });
    this.settingElement.setTooltipVisible(false);

    button.on('pointerup', (e: any) => {
      if (shouldSubmitOnPointerUp(e)) {
        PhaserAudioManager.playSFX(radioButton.scene, 'submit-click');
        this.onUserSelect?.(radioButton);
      }
    });

    interactionHitbox.on('pointerup', (e: any) => {
      if (shouldSubmitOnPointerUp(e)) {
        PhaserAudioManager.playSFX(radioButton.scene, 'submit-click');
        this.onUserSelect?.(radioButton);
      }
    });

    settingLabel.on('pointerover', () => {
      this.settingElement.setTooltipVisible(true);
    });

    settingLabel.on('pointerout', () => {
      this.settingElement.setTooltipVisible(false);
    });
    radioButton.tooltipDisabledCover.setInteractive({
      cursor: `${HOVER_CURSOR_PATH}, auto`,
    });
    radioButton.tooltipDisabledCover.on('pointerover', () => {
      this.settingElement.setTooltipVisible(true);
    });
    radioButton.tooltipDisabledCover.on('pointerout', () => {
      this.settingElement.setTooltipVisible(false);
    });
  }

  public settingElement: SettingElement;
  isSelected: boolean = false;
  public IsInteractive: boolean = true;
  onUserSelect?: (button: RadioButton) => void;

  interactiveColor: number = 0x52333f;
  disabledColor: number = 0xbfb09e;

  getIsSelected() {
    return this.isSelected;
  }

  setSelected(isSelected: boolean) {
    this.isSelected = isSelected;
    if (this.IsInteractive) {
      this.radioButton.button.setTexture(
        isSelected ? 'radio on 02' : 'radio off',
      );
    }
  }

  makeInteractive(isInteractive: boolean) {
    const { button, settingLabel } = this.radioButton;
    this.radioButton.tooltipDisabledCover.setVisible(!isInteractive);
    this.IsInteractive = isInteractive;
    if (isInteractive) {
      this.radioButton.button.setInteractive({
        cursor: `${HOVER_CURSOR_PATH}, auto`,
      });
      this.radioButton.settingLabel.setInteractive({
        cursor: `${HOVER_CURSOR_PATH}, auto`,
      });
      button.setTexture(this.isSelected ? 'radio on 02' : 'radio off');
      setBitmapColor(settingLabel, this.interactiveColor);
    } else {
      button.disableInteractive();
      settingLabel.disableInteractive();
      button.setTexture('radio disabled 01');
      setBitmapColor(settingLabel, this.disabledColor);
    }
  }
}
